{
    "ug": {
        "Yes": "ھەئە",
        "No": "ياق",
        "Cancel": "ۋاز كېچىش",
        "Close": "تاقاش",
        "Clear": "تازىلاش",
        "Done": "تامام",
        "Loading": "يۈكلىنىۋاتىدۇ...",
        "Select": "تاللاش...",
        "Search": "ئىزدەش",
        "Back": "قايتىش",
        "OK": "ماقۇل",
        "dxCollectionWidget-noDataText": "سانلىق مەلۇمات يوق",
        "dxList-pullingDownText": "يېڭىلاش ئۈچۈن تۆۋەنگە تارتىڭ...",
        "dxList-pulledDownText": "يېڭىلاش ئۈچۈن قويۇۋېتىڭ...",
        "dxList-refreshingText": "يېڭىلىنىۋاتىدۇ...",
        "dxList-pageLoadingText": "يۈكلىنىۋاتىدۇ...",
        "dxList-nextButtonText": "تېخىمۇ كۆپ",
        "dxList-selectAll": "ھەممىنى تاللاش",
        "dxDataGrid-noDataText": "سانلىق مەلۇمات يوق"
    }
}
